const onQuantityButtonClick = (isDecrement, button, parent) => {
    if (!parent || !button) {
        return;
    }

    const input = parent.querySelector('input');

    if (!input) {
        return;
    }

    const currentMax = Number.isNaN(parseInt(input.getAttribute('max'), 10))
        ? 9999
        : parseInt(input.getAttribute('max'), 10);
    const currentMin = parseInt(input.getAttribute('min'), 10) || 0;
    const inputDecrement = parent.querySelector('[js-decrement]');
    const inputIncrement = parent.querySelector('[js-increment]');
    const currentValue = parseInt(input.value, 10) || 0;
    const newValue = isDecrement ? currentValue - 1 : currentValue + 1;

    if (isDecrement && newValue < currentMin) {
        return;
    }

    if (!isDecrement && newValue > currentMax) {
        return;
    }

    input.value = String(newValue);

    if (inputDecrement) {
        inputDecrement.classList.toggle('disabled', newValue <= currentMin);
    }

    if (inputIncrement) {
        inputIncrement.classList.toggle('disabled', newValue >= currentMax);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));

    const updateButton = document.querySelector("[name='update_cart']");

    if (updateButton) {
        updateButton.click();
    }
};

const initQuantityInputObservers = (root = document) => {
    const scope = root instanceof Element ? root : document;

    scope.querySelectorAll('[js-quantity-input]').forEach(element => {
        if (element.dataset.qtyObserverInit === '1') {
            return;
        }

        const input = element.querySelector('input');
        const inputIncrement = element.querySelector('[js-increment]');

        if (!input || !inputIncrement) {
            return;
        }

        element.dataset.qtyObserverInit = '1';

        const observer = new MutationObserver(() => {
            const currentValue = parseInt(input.value, 10) || 0;
            const currentMax = parseInt(input.getAttribute('max'), 10)
                ? parseInt(input.getAttribute('max'), 10)
                : 9999;

            inputIncrement.classList.toggle(
                'disabled',
                currentValue >= currentMax
            );
        });

        observer.observe(input, {
            attributes: true,
            attributeFilter: ['max'],
        });
    });
};

if (!window.__mdaQuantityInputClickBound) {
    window.__mdaQuantityInputClickBound = true;

    window.addEventListener('click', event => {
        const decrementButton = event.target.closest('[js-decrement]');
        const incrementButton = event.target.closest('[js-increment]');

        if (!decrementButton && !incrementButton) {
            return;
        }

        const parent = event.target.closest('[js-quantity-input]');

        if (!parent) {
            return;
        }

        onQuantityButtonClick(
            Boolean(decrementButton),
            decrementButton || incrementButton,
            parent
        );
    });
}

initQuantityInputObservers(document);
window.mdaInitQuantityInputs = initQuantityInputObservers;
